"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConfigStore = /** @class */ (function () {
    function ConfigStore() {
        this.name = '';
        this.model = null;
        this.actions = null;
        this.containsNestedProps = false;
        this.emitOnSubscription = true;
        Object.seal(this);
    }
    return ConfigStore;
}());
exports.default = ConfigStore;
//# sourceMappingURL=ConfigStore.js.map